export function formatMoney(number: any, currency = 'EUR'): any {
  if (isNaN(parseFloat(number))) {
    return 'NaN';
  }

  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(parseFloat(number));
}
